var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16374 19.9447C6.87981 19.9447 7.46029 19.3642 7.46029 18.6481C7.46029 17.9321 6.87981 17.3516 6.16374 17.3516C5.44767 17.3516 4.86719 17.9321 4.86719 18.6481C4.86719 19.3642 5.44767 19.9447 6.16374 19.9447Z",
    fill: "#252F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5856 19.9447C14.3017 19.9447 14.8822 19.3642 14.8822 18.6481C14.8822 17.9321 14.3017 17.3516 13.5856 17.3516C12.8695 17.3516 12.2891 17.9321 12.2891 18.6481C12.2891 19.3642 12.8695 19.9447 13.5856 19.9447Z",
    fill: "#252F3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.67578H16.2621L13.9724 14.5103H5.61379L4.2069 9.90337H2L4.26207 16.7723H15.3241L17.8897 8.4413H22V6.67578Z",
    fill: "#252F3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0859 8.08235L12.5687 9.24097L15.0515 5.26855H10.0859V8.08235Z",
    fill: "#00A4CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0531 8.08235L12.5703 9.24097V5.29614L15.0531 5.26855V8.08235Z",
    fill: "#038DB9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5687 4L10.0859 5.26896L12.5687 6.4L15.0515 5.26896L12.5687 4Z",
    fill: "#34C1DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45703 8.08235L6.9122 9.24097L9.42255 5.26855H4.45703V8.08235Z",
    fill: "#EF7C22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42441 8.08235L6.91406 9.24097V5.26855H9.42441V8.08235Z",
    fill: "#E46025"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9122 4L4.45703 5.26896L6.9122 6.4L9.42255 5.26896L6.9122 4Z",
    fill: "#F7972C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26953 12.7178L9.75229 13.8765L12.235 9.82129H7.26953V12.7178Z",
    fill: "#1F66AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2367 12.7178L9.75391 13.8765V9.82129H12.2367V12.7178Z",
    fill: "#13519D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75229 8.66211L12.235 9.82073L9.75229 11.0345L7.26953 9.82073L9.75229 8.66211Z",
    fill: "#187EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsMarketplace);
export default __webpack_public_path__ + "static/media/aws_marketplace.71e2c6f21e66b5fcca0e39dcc04351b0.svg";
export { ForwardRef as ReactComponent };